import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import patchCart from "../api-calls/patch-cart";
import getCartQueryKey from "../get-query-key";
import getGlobalConfigQueryKey from "../../../../global-config/get-query-key";
import getCartReviewsQueryKey from "../../../cart_reviews/v2/get-query-key";
import getPartnerCartReviewsQueryKey from "../../../partner_cart_reviews/v1/get-query-key";
import getPartnerCartReviewsV2QueryKey from "../../../partner_cart_reviews/v2/get-query-key";
import handleCartWarnings from "../utils/handle-warnings";
import determineCartReviewsVersion, { CART_REVIEWS_V2, PARTNER_CART_REVIEWS_V2, PARTNER_CART_REVIEWS_V1 } from "../utils/determine-cart-reviews-version";
var getRemovePromotionCodeOptions = function getRemovePromotionCodeOptions(_ref) {
  var queryClient = _ref.queryClient;
  // Helper to get the appropriate query key based on cart reviews version
  var getCartReviewsQueryKeyForVersion = function getCartReviewsQueryKeyForVersion() {
    var globalConfig = queryClient.getQueryData(getGlobalConfigQueryKey());
    var _ref2 = globalConfig || {},
      isGlobalStoreCountry = _ref2.isGlobalStoreCountry;
    var cartReviewsPath = determineCartReviewsVersion({
      isGlobalStoreCountry: isGlobalStoreCountry
    });
    if (cartReviewsPath === CART_REVIEWS_V2) {
      return getCartReviewsQueryKey();
    } else if (cartReviewsPath === PARTNER_CART_REVIEWS_V2) {
      return getPartnerCartReviewsV2QueryKey();
    } else if (cartReviewsPath === PARTNER_CART_REVIEWS_V1) {
      return getPartnerCartReviewsQueryKey();
    }
    // Fallback to cart_reviews as default
    return getCartReviewsQueryKey();
  };
  return {
    mutationFn: function () {
      var _mutationFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var promotionCode;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              promotionCode = _ref3.promotionCode;
              return _context.abrupt("return", patchCart({
                actions: [{
                  op: 'remove',
                  path: '/promotionCodes',
                  value: promotionCode
                }]
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function mutationFn(_x) {
        return _mutationFn.apply(this, arguments);
      }
      return mutationFn;
    }(),
    onMutate: function onMutate(_ref4) {
      var promotionCode = _ref4.promotionCode;
      // optimistically remove promo code from cartReviews
      var queryKey = getCartReviewsQueryKeyForVersion();
      queryClient.invalidateQueries(queryKey);
      queryClient.setQueryData(queryKey, function (cartReviews) {
        var _response$fulfillment, _currentFulfillmentGr, _response$promotionCo;
        if (!(cartReviews !== null && cartReviews !== void 0 && cartReviews.response)) {
          return cartReviews;
        }
        var response = cartReviews.response;
        var currentFulfillmentGroup = response === null || response === void 0 || (_response$fulfillment = response.fulfillmentGroups) === null || _response$fulfillment === void 0 ? void 0 : _response$fulfillment[0];

        // remove from cartReviews.response.fulfillmentGroups[0].items[$].itemCosts.promotionDiscounts[0]
        var itemsWithPromoCodesRemoved = (currentFulfillmentGroup === null || currentFulfillmentGroup === void 0 || (_currentFulfillmentGr = currentFulfillmentGroup.items) === null || _currentFulfillmentGr === void 0 ? void 0 : _currentFulfillmentGr.map(function (item) {
          var _item$itemCosts;
          var promotionDiscounts = ((_item$itemCosts = item.itemCosts) === null || _item$itemCosts === void 0 ? void 0 : _item$itemCosts.promotionDiscounts) || [];
          return _objectSpread(_objectSpread({}, item), {}, {
            itemCosts: _objectSpread(_objectSpread({}, item.itemCosts), {}, {
              promotionDiscounts: promotionDiscounts.filter(function (promoCode) {
                return promoCode.code !== promotionCode;
              })
            })
          });
        })) || [];
        return _objectSpread(_objectSpread({}, cartReviews), {}, {
          isPromosUpdating: true,
          response: _objectSpread(_objectSpread(_objectSpread({}, response), currentFulfillmentGroup && {
            fulfillmentGroups: [_objectSpread(_objectSpread({}, currentFulfillmentGroup), {}, {
              items: itemsWithPromoCodesRemoved
            })]
          }), {}, {
            // remove from cartReviews.response.promotionCodes
            promotionCodes: (_response$promotionCo = response.promotionCodes) === null || _response$promotionCo === void 0 ? void 0 : _response$promotionCo.filter(function (promoCode) {
              return promoCode.code !== promotionCode;
            })
          })
        });
      });
      return {
        meta: {
          dispatchCartUpdated: true
        }
      };
    },
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
        var _ref5,
          promotionCode,
          queryKey,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref5 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, promotionCode = _ref5.promotionCode;
              queryClient.setQueryData(getCartQueryKey(), data);
              queryKey = getCartReviewsQueryKeyForVersion();
              queryClient.invalidateQueries({
                queryKey: queryKey
              });
              try {
                if (data !== null && data !== void 0 && data.id && promotionCode) {
                  window.webShellClient.analytics.trackAction({
                    underlyingAction: {
                      "case": 'coreCommerceV1CartModified',
                      value: {
                        cartId: data.id,
                        operation: {
                          "case": 'promoCodeRemoved',
                          value: {
                            value: promotionCode
                          }
                        }
                      }
                    }
                  });
                }
              } catch (e) {
                // Analytics failures must never interrupt promo removal UX.
              }

              // Handle warnings if present in the response
              if (!(data !== null && data !== void 0 && data.warnings && data.warnings.length > 0)) {
                _context2.next = 1;
                break;
              }
              _context2.next = 1;
              return handleCartWarnings({
                warnings: data.warnings,
                data: data
              }, queryClient);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function onSuccess(_x2) {
        return _onSuccess.apply(this, arguments);
      }
      return onSuccess;
    }()
  };
};
export default getRemovePromotionCodeOptions;